import React from 'react'
import { Grid } from '@material-ui/core'
import TableViagemAtual from './TableViagemAtual'
import CardsQuantidades from './CardsQuantidades'
import { useFilter, Filter } from 'elentari'
import GerenciadoraField from '../../../Tarefa/Fields/GerenciadoraField'

function PainelTarefasLiberadaViagemFilter() {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Mostrar', clear: 'Limpar' }}>
      <Grid container spacing={2}>
        <Grid item sm={3} xs={12}>
          <GerenciadoraField />
        </Grid>
      </Grid>
    </Filter>
  )
}

const PainelTarefasLiberadaViagem = props => {
  return (
    <>
      <PainelTarefasLiberadaViagemFilter />
      <Grid container spacing={2}>
        <CardsQuantidades {...props} />
        <TableViagemAtual {...props} />
      </Grid>
    </>
  )
}

export default React.memo(PainelTarefasLiberadaViagem)
